import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { TextField } from "@material-ui/core";
import { BOOST_DATA_QUERY } from "components/Pages/CustomerSupport/BoostSubscriptionManager/query";
import { Dropdown } from "components/common";
import { PRODUCT_CANCELLATION_FEEDBACK } from "utils/constants";
import { STRIPE_SUBSCRIPTION_STATUSES } from "components/Pages/Boost/consts";

export const CANCEL_BOOST_SUBSCRIPTION = gql`
  mutation CancelBoostSubscription($input: CancelBoostSubscriptionInput) {
    cancelBoostSubscription(input: $input) {
      status
      code
      message
      display_message
    }
  }
`;

/**
 * @param {{ email: string }} props - (Required) email of user to cancel subscription
 * @returns {React.ReactNode}
 */
const CancelBoostSubscriptionModal = (props) => {
  const { email, closeModal, status } = props;
  const isDisabled = status === STRIPE_SUBSCRIPTION_STATUSES.PAST_DUE;
  const [comment, setComment] = useState("");
  const [feedback, setFeedback] = useState(PRODUCT_CANCELLATION_FEEDBACK.other);
  const [cancelSubscription, { loading, error }] = useMutation(
    CANCEL_BOOST_SUBSCRIPTION,
    {
      variables: { input: { email, comment, feedback } },
      onCompleted: closeModal,
      refetchQueries: [{ query: BOOST_DATA_QUERY, variables: { email } }],
    },
  );
  const errorMessage =
    error?.graphQLErrors?.length > 0 ? error.graphQLErrors[0].message : "";

  const feedbackSelections = Object.keys(PRODUCT_CANCELLATION_FEEDBACK).map(
    (key) => ({
      value: key,
      name: PRODUCT_CANCELLATION_FEEDBACK[key],
    }),
  );

  return (
    <div
      style={{ backgroundColor: "#FAFAFA", minWidth: 400 }}
      className="py-8 px-12 flex flex-col items-center max-w-2xl"
    >
      <h1>Confirm Cancellation</h1>
      <p>
        Marking a subscription for cancellation will prevent you from pausing
        payments and scheduling downgrades.
      </p>
      <p>You can undo this action.</p>
      <TextField
        style={{ marginTop: 16 }}
        className="w-full"
        id="comment"
        label="Comment"
        variant="outlined"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <h2 className="mt-4 self-start">Feedback</h2>
      <Dropdown
        className="mt-1"
        elements={feedbackSelections}
        selectedElement={feedback}
        didSelect={(e) => setFeedback(e.value)}
      />
      {isDisabled && (
        <p>
          Feedback cannot be left for subscriptions which will cancel
          immediately
        </p>
      )}
      <button
        type="button"
        className="mt-4 ml-4 btn-green text-white px-3 py-1"
        onClick={cancelSubscription}
        disabled={loading}
      >
        {loading ? "Cancelling..." : "Confirm"}
      </button>
      <p className="mt-1 text-red-500">{errorMessage}</p>
    </div>
  );
};

export default CancelBoostSubscriptionModal;
